import { jsxs as r, jsx as i } from "react/jsx-runtime";
import { Icon as m } from "../../atoms/Icon/Icon.mjs";
import { cn as o } from "../../../utils/utils.mjs";
function a({ children: e, className: t }) {
  return /* @__PURE__ */ r("div", { className: o("flex flex-col items-center gap-3", t), children: [
    /* @__PURE__ */ i(m, { name: "image", width: 24, height: 24 }),
    e
  ] });
}
export {
  a as DefaultState
};
